import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { GlobalErrorComponent } from './shared/global-error/global-error.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.route').then((m) => m.HomeRoutes)
  },
  {
    path: 'activeStudies',
    loadChildren: () =>
      import('./features/active-studies/active-studies-route').then(
        (m) => m.ActiveStudiesRoutes
      )
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./features/profile/profile-route').then((m) => m.ProfileRouts),
      canActivate: [MsalGuard]
  },
  {
    path: 'studyDetail',
    loadChildren: () =>
      import('./features/study-detail/study-route').then(
        (m) => m.StudyDetailRoutes
      )
  },
  {
    path: 'labsiteInformation/:contentType',
    loadChildren: () =>
      import('./features/labsiteInformation/labsiteInformation.route').then(
        (m) => m.LabsiteInformationRoutes
      )
  },
  {
    path: 'newsPageInformation',
    loadChildren: () =>
      import('./features/newsPageInformation/newsPageInformation.route').then(
        (m) => m.NewsPageInformationRoutes
      )
  },
  {
    path: 'caseReportFormStudies',
    loadChildren: () =>
      import('./features/caseReportFormStudies/caseReportFormStudies.route').then(
        (m) => m.CaseReportFormStudiesRoutes
      )
  },
  {
    path: '**',
   component: GlobalErrorComponent
  },
  // {
  //   path: "**",
  //   redirectTo: ""
  //  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: PreloadAllModules,
    initialNavigation: 'enabledBlocking' //Modifed from enabled to enabledBlocking as this is not allowed field in angular
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
